import { render, staticRenderFns } from "./documenti.html?vue&type=template&id=4b12f57c&"
import script from "./Documenti.vue?vue&type=script&lang=js&"
export * from "./Documenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports